// services/lessonService.js
import { create, getAll, getById, update, remove } from './baseService';

const endpoint = 'lessons';

const lessonService = {
  // Tạo bài học mới
  createLesson: async (lesson) => {
    return create(endpoint, lesson); // Gọi API POST /lessons
  },

  // Lấy danh sách bài học
  getAllLessons: async (params = {}) => {
    return getAll(endpoint, params); // Gọi API GET /lessons
  },

  getLessonByIdAndCourseId: async (id,course_id) => {
    return getById(`${endpoint}/${id}/course`,course_id); // Gọi API GET /lessons/:id
  },

  // Lấy bài học theo ID
  getLessonById: async (id) => {
    return getById(endpoint, id); // Gọi API GET /lessons/:id
  },

   // Lấy bài học theo ID
   getLessonByCourseId: async (id) => {
    return getById(`${endpoint}/course`, id); // Gọi API GET /lessons/:id
  },

  // Cập nhật bài học
  updateLesson: async (id, updatedLesson) => {
    return update(endpoint, id, updatedLesson); // Gọi API PUT /lessons/:id
  },

  // Xóa bài học
  deleteLesson: async (id) => {
    return remove(endpoint, id); // Gọi API DELETE /lessons/:id
  },
};

export default lessonService;
